const _physicianPortalEventId = Symbol();
const _physicianPortalEventDate = Symbol();
const _createdDate = Symbol();
const _activityNote = Symbol();

const coalesce = (...args) => {
	return args.find(arg => arg !== undefined);
};

export class PhysicianPortalEvent {
	constructor(physicianPortalEventId, physicianPortalEventDate, createdDate, activityNote) {
		this.physicianPortalEventId = physicianPortalEventId;
		this.physicianPortalEventDate = physicianPortalEventDate;
		this.createdDate = createdDate;
		this.activityNote = activityNote;
	}
	get physicianPortalEventId() {
		return this[_physicianPortalEventId];
	}
	set physicianPortalEventId(v) {
		if(!Number.isInteger(v))
			throw new TypeError('physicianPortalEventId must be an integer.');
		this[_physicianPortalEventId] = v;
	}
	get physicianPortalEventDate() {
		return this[_physicianPortalEventDate];
	}
	set physicianPortalEventDate(v) {
		if(!Number.isInteger(v))
			throw new TypeError('physicianPortalEventDate must be an integer.');
		this[_physicianPortalEventDate] = v;
	}
	get createdDate() {
		return this[_createdDate];
	}
	set createdDate(v) {
		if(!Number.isInteger(v))
			throw new TypeError('createdDate must be an integer.');
		this[_createdDate] = v;
	}
	get activityNote() {
		return this[_activityNote];
	}
	set activityNote(v) {
		if(typeof v !== 'string')
			throw new TypeError('activityNote must be a string.');
		this[_activityNote] = v;
	}
	toJSON() {
		return {
			physicianPortalEventId: this.physicianPortalEventId,
			physicianPortalEventDate: this.physicianPortalEventDate,
			createdDate: this.createdDate,
			activityNote: this.activityNote
		};
	}
	static fromObject(obj) {
		if(obj === null || typeof obj !== 'object')
			throw new TypeError('obj must be an object.');
		return new this (
			coalesce(obj.physicianPortalEventId, obj.PhysicianPortalEventId, null),
			coalesce(obj.physicianPortalEventDate, obj.PhysicianPortalEventDate) instanceof Date ? 
				coalesce(obj.physicianPortalEventDate,  obj.PhysicianPortalEventDate).getTime() : 
				(obj.physicianPortalEventDate || obj.PhysicianPortalEventDate)
				|| null,
			coalesce(obj.createdDate, obj.CreatedDate) instanceof Date ? 
				coalesce(obj.createdDate,  obj.CreatedDate).getTime() : 
				(obj.createdDate || obj.CreatedDate)
				|| null,
			coalesce(obj.activityNote, obj.ActivityNote, null)
		);
	}
}